<template>
  <FontAwesomeLayers
    v-if="isLayered"
    :fixed-width="fixedWidth"
    :class="size"
  >
    <template
      v-for="(layer, index) in layers"
      :key="index"
    >
      <FontAwesomeIcon
        v-if="layer.type === 'icon'"
        :icon="layer.icon"
        :transform="layer.transform"
        :style="layer.style"
        :class="layer.class"
      />
      <FontAwesomeLayersText
        v-if="layer.type === 'text'"
        :value="layer.value"
        :transform="layer.transform"
        :style="layer.style"
        :class="layer.class"
      />
      <FontAwesomeLayersText
        v-else-if="layer.type === 'counter'"
        :value="layer.value"
        :transform="layer.transform"
        :style="layer.style"
        :class="layer.class"
        :counter="true"
        :position="layer.position"
      />
    </template>
  </FontAwesomeLayers>
  <FontAwesomeIcon
    v-else-if="icon"
    :icon="icon"
    :class="size"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { config, type IconDefinition } from '@fortawesome/fontawesome-svg-core'
// 1. IMPORT THE CORE CSS
import '@fortawesome/fontawesome-svg-core/styles.css'
import {
  FontAwesomeIcon,
  FontAwesomeLayers,
  FontAwesomeLayersText,
} from '@fortawesome/vue-fontawesome'
import { size } from 'lodash-es'

config.autoAddCss = false

interface IconLayer {
  type: 'icon'
  // name: string
  // variant: string
  icon: IconDefinition
  transform?: string
  style?: Record<string, unknown>
  class?: string
}

interface TextLayer {
  type: 'text'
  value: string | number
  transform?: string
  style?: Record<string, any>
  class?: string
}
interface CounterLayer {
  type: 'counter'
  value: string | number
  transform?: string
  position?: 'bottom-left' | 'bottom-right' | 'top-left' | 'top-right' | undefined
  style?: Record<string, any>
  class?: string
}

type Layer = IconLayer | TextLayer | CounterLayer

interface BaseProps {
  fixedWidth?: boolean
  size?: string
}

type SingleIcon = {
  icon: IconDefinition
  layers?: never
}

type LayeredIcon = {
  layers: Layer[]
  icon?: never
}

type IconProps = BaseProps & (SingleIcon | LayeredIcon)

const props = defineProps<IconProps>()

// Store all dynamically loaded icon definitions - shallow ref for performance, we dont intend to change
const isLayered = computed(() => !!props.layers && props.layers.length > 0)
</script>
